import React, { useEffect, useState, useMemo } from "react";
import ReactToPrint from "react-to-print";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styling.css"
import { InputLabel, Select, MenuItem, FormControl, Box,ListSubheader,TextField,InputAdornment } from '@mui/material';
import company from "../../assets/company.png"
import SearchIcon from "@mui/icons-material/Search";
import axios from 'axios'
import { Link } from "react-router-dom"
import { FaAngleDown } from "react-icons/fa6";

const containsText = (text, searchText) =>
  text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

const NoteForm = ({handleChild}) => {

    const today = new Date().toISOString().split('T')[0];
    const currentTime = new Date().toLocaleTimeString('en-US', {
        hour12: false,
        hour: 'numeric',
        minute: 'numeric',
      });
    const defaultLogoUrl = company;
    const [companylogo, setCompanyLogo] = useState(defaultLogoUrl);
    const [clientAddress, setClientAddress] = useState("");
    const [notenumber, setnotenumber] = useState("");
    const [noteDate, setNoteDate] = useState(today);
    const [time, setTime] = useState(currentTime);
    const [quantity, setQuantity] = useState("");
    const [delQuantity,setDelQuantity] = useState("")
    const [stock,setStock] = useState("")
    const [price, setPrice] = useState("");
    const [priceSQM, setPriceSQM] = useState("");
    const [pricePC, setPricePC] = useState("");
    const [priceSHT, setPriceSHT] = useState("");
    const [priceLMTR, setPriceLMTR] = useState("");
    const [amount, setAmount] = useState("0");
    const [list, setList] = useState([]);
    const [total, setTotal] = useState(0);
    const [notes, setNotes] = useState("");
    const [id, setID] = useState("");
    const [clientID, setClientID] = useState("");

    const [selectedItem, setSelectedItem] = useState("");
    const [selectedItem2, setSelectedItem2] = useState("");
    const [selectedUnit,setSelectedUnit] = useState("")

    const [type,setType] = useState("")

    //edit name
    const [selectedItemName, setSelectedItemName] = useState("");
    const [selectedItemName2, setSelectedItemName2] = useState("");

    const [ItemData, setItemData] = useState([]);
    const [searchText, setSearchText] = useState("");
    const displayedOptions = useMemo(
        () =>
          searchText
            ? ItemData.filter(
                (item) =>
                  containsText(item.itemservice, searchText) ||
                  containsText(item.id.toString(), searchText)
              )
            : ItemData,
        [ItemData,searchText]
      );


    const [Salesman, setSalesman] = useState("");
    const [salesmanId, setSalesmanId] = useState("");

    const [SalesmanData, setSalesmanData] = useState([]);

    const componentRef = React.createRef();

    const [ClientData, setClientData] = useState([]);
    const [lpoNumber, setLpoNumber] = useState([]);


    const [Clientname, setClientname] = useState("");
    const [searchTextClient, setSearchTextClient] = useState("");
    const displayedClientOptions = useMemo(
        () =>
          searchTextClient
            ? ClientData.filter(
                (client) =>
                  containsText(client.firstname, searchTextClient) ||
                  containsText(client.lastname, searchTextClient) ||
                  containsText(client.id.toString(), searchTextClient)
              )
            : ClientData,
        [ClientData, searchTextClient]
      );


    const [ClientPhone, setClientPhone] = useState("");
    const [productData, setProductData] = useState([]);
    const [searchText2, setSearchText2] = useState('');
    const displayedOptions2 = useMemo(
      () =>
        searchText2
          ? productData.filter(
              (product) =>
                containsText(product.product_name, searchText2) ||
                containsText(product.id.toString(), searchText2)
            )
          : productData,
      [productData,searchText2]
    );

    const [toggle,setToggle]=useState(null);
    const [unitData,setUnitData]=useState([]);

    //edit name
    const [editName, setEditName] = useState(false);

    const NameToggle = () => {
        setEditName(!editName)
    };

    const handleLogoChange = (event) => {
        const newLogoUrl = URL.createObjectURL(event.target.files[0]);
        setCompanyLogo(newLogoUrl);
    };

    useEffect(() => {
        const fetchAll_notes = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/notes/all_notes`);
                const responseData = await response.json(); 
        
                setnotenumber("Added upon print");

            } catch (error) {
                console.log(error.message);
            }
        };
        
          fetchAll_notes();
        const fetchClients = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/clients/all_clients`
                );
                const responseData = await response.json();
                if (responseData) {
                    setClientData(responseData.client);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        const fetchItems = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/itemservices/all_itemservices`
                );
                const responseData = await response.json();
                if (responseData) {
                    setItemData(responseData.itemservice);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        const fetchSalesmen = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/salesman/all_salesmen`
                );
                const responseData = await response.json();
                if (responseData) {
                    setSalesmanData(responseData.salesmen);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        const fetchProducts = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_BASE_URL}/products/all_products`
                );
                const responseData = await response.json();
                if (responseData) {
                    setProductData(responseData.product);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        }
        fetchSalesmen();
        fetchClients();
        fetchItems();
        fetchProducts()

    }, []);


    useEffect(() => {
        if (selectedItem.length!==0) {
            const selectedItemData = ItemData.find(
                (item) => item.itemservice === selectedItem
            );
            if (selectedItemData) {
                setSelectedItem2("")
                // setPrice(selectedItemData.rate );
                setPriceSQM(selectedItemData.rateSQM);
                setPricePC(selectedItemData.ratePC);
                setPriceSHT(selectedItemData.rateSHT);
                setPriceLMTR(selectedItemData.rateLMTR);
                const calculatedAmount = (price || priceSQM || pricePC || priceSHT || priceLMTR) * quantity;
                setAmount(calculatedAmount);
                setID(selectedItemData.id)
                setType(selectedItemData.type)
            }
        }
        if(selectedItem2.length!==0){
            const selectedItemData = productData.find(
                (product) => product.product_name === selectedItem2
            );
            if (selectedItemData) {
                setSelectedItem("")
                // setPrice(selectedItemData.product_rate);
                const calculatedAmount = price * quantity;
                setAmount(calculatedAmount);
                setID(selectedItemData.id)
                setType("product")
            }
        }
    }, [selectedItem,quantity, selectedItem2, priceSQM, pricePC, priceSHT, priceLMTR]);

    const priceFunc = (selUnit) => {
        const temp = unitData.filter((unit)=>unit.uom===selUnit)
        setPrice(temp[0].price)
    };

    //UOM item
    const [itemId,setItemId]=useState(null)
    useEffect(()=>{
        async function get_UOM(){
     
            try {
                const requestOptions = {
                    method: 'POST', // or 'PUT', 'DELETE', etc. depending on your API endpoint
                    headers: {
                    'Content-Type': 'application/json', // Specify the content type
                    },
                    body: JSON.stringify({ item_id: `itm${itemId}` }), // Convert your body data to JSON format
                };
 
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/invoices/get_UOM`,requestOptions);
                const responseData = await response.json()
                if (responseData) {
                    setUnitData(responseData.invoice)
                }
            } catch (error) {
                console.log(error.message);
            }
        }
        get_UOM()

    },[selectedItem])


    //UOM product
    const [productId,setProductId]=useState(null)
    useEffect(()=>{
        async function get_UOM(){
     
            try {
                const requestOptions = {
                    method: 'POST', // or 'PUT', 'DELETE', etc. depending on your API endpoint
                    headers: {
                    'Content-Type': 'application/json', // Specify the content type
                    },
                    body: JSON.stringify({ item_id: `pd${productId}` }), // Convert your body data to JSON format
                };
 
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/invoices/get_UOM`,requestOptions);
                const responseData = await response.json()
                if (responseData) {
                    setUnitData(responseData.invoice)
                }
            } catch (error) {
                console.log(error.message);
            }
        }
        get_UOM()

    },[selectedItem2])

    useEffect(() => {
        const calculatedAmount = price * quantity;
        setAmount(calculatedAmount);
    }, [price, quantity])

    const addToTable = () => {
        if ((selectedItem||selectedItem2) && id && quantity && price && amount && checkProduct()) {

            const newItem = {
                id: id,
                itemdesc: selectedItem.length > 0 ? selectedItemName : selectedItemName2,
                quantity: quantity,
                price: price,
                uom:selectedUnit,
                delQuantity:delQuantity,
                amount: amount,
                type:type
            };

            setList([...list, newItem]);

            setDelQuantity("")
            setSelectedItem("");
            setQuantity("");
            setPrice("");
            setAmount("");
            setSelectedUnit("")
            setType("")
        }
    };

    const removeItem = (index) => {
        const updatedList = [...list];
        updatedList.splice(index, 1);
        setList(updatedList);
    };

    const clearFields = () => {
        setAmount("0")
        setTime("")
        setNoteDate("")
        setClientAddress("")
        setClientID("")
        setClientname("")
        setLpoNumber("")
        setList([])
        setSalesman("")
        setClientPhone("")
        setNotes("")
        setnotenumber("")
        setSelectedItem("")
        setTotal(0)
        setQuantity("")
        setPrice("")
        setType("")
        setDelQuantity("")
    }

    useEffect(() => {
        const calculateTotal = () => {
            let totalAmount = 0;
            list.forEach(({ amount }) => {
                totalAmount += parseFloat(amount);
            });
            return totalAmount;
        };
        const newTotal = calculateTotal();
        setTotal(newTotal);
    }, [list]);


    const deleteSalesman = async () => {
        try {
            const selectedSalesman = SalesmanData.find((salesman) => salesman.fullname === Salesman);

            if (!selectedSalesman) {
                console.error("Selected salesman not found.");
                return;
            }

            const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/salesman/delete_salesman`, {
                data: {
                    id: selectedSalesman.id
                }
            });

            if (response.status === 200) {
                toast.error('Salesman deleted successfully!');
                setSalesman("");
            } else {
                console.error("Error deleting salesman. Status code:", response.status);
            }
        } catch (error) {
            console.error("Error deleting salesman:", error);
        }
    };

    const handleClientChange = (selectedClientName) => {
        const selectedClient = ClientData.find((client) => client.companyname === selectedClientName);
        if (selectedClient) {
            setClientAddress(selectedClient.address || "");
            setClientPhone(selectedClient.phone || "");
            setClientID( selectedClient.id || "")
            setLpoNumber( selectedClient.lponumber || "")

        }
    };

    const [triggerNote,setTriggerNote] = useState(true)
    const [triggerPrint, setTriggerPrint] = useState(false)

    const addNote = async () => {
        if (!Salesman || !Clientname || !time || !noteDate || !total || !list) {
            toast.warn("Fill out the fields")
            return
        }
        try {
            setAddNoteButtonStatetext("Creating, please wait!")
            const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/notes/add_note`, {
                "notenumber": notenumber,
                "salesman": Salesman,
                "salesmanid": salesmanId,
                "client": Clientname,
                "clientid": clientID,
                "clientlpo":lpoNumber,
                "clientaddress": clientAddress,
                "clientphone":ClientPhone,
                "time": time,
                "notes": notes,
                "issuedate": noteDate,
                "total": total,
                "items": list
            })
            if (response.status === 200) {
                toast.success("Note created successfully!")
                setAddNoteButtonStatetext("Create Note")
                setnotenumber(`ARDN${response.data.note}`)
                setTriggerNote(false)
                setTriggerPrint(true)
            }
            else {
                toast.error("Error creating note.")
            }
        } catch (error) {
            console.error(error.message);
            toast.error("Error creating note.")
        }
    }

    const [AddNoteButtonStatetext, setAddNoteButtonStatetext] = useState('Create Note');

    //check Product
    function checkProduct(){
        if(selectedItem.length>0){
            return true
        }

        else{

            const res = prodItem.map((prodItem)=>{

                const selItem = ItemData.filter((item)=>item.id===prodItem.item_id)
                
                return (prodItem.item_quantity*quantity<=selItem[0]?.currentstock)?true:false
            })
            if(res[0]===false){
                toast.warn(`Not Enough quantity of one of the items in Bundled Product "${selectedItem2}"`)
            }
            return res[0]
        }
    }

    //stock

    function itemStockFunc(selectedItemTemp){

        const selItem = ItemData.filter((item)=>item.itemservice===selectedItemTemp)
        setStock(selItem[0]?.currentstock)
       }


    //item info

    const [prodItem,setProdItem] = useState(null)
    async function getItemInfo(selectedItemTemp){

        try {
            const requestOptions = {
                method: 'POST', // or 'PUT', 'DELETE', etc. depending on your API endpoint
                headers: {
                'Content-Type': 'application/json', // Specify the content type
                },
                body: JSON.stringify({ id: selectedItemTemp }), // Convert your body data to JSON format
            };

            const response = await fetch(
                `${process.env.REACT_APP_BASE_URL}/products/get_productItems`,requestOptions
            );
            const responseData = await response.json(); 

            if (responseData) {
                setProdItem(responseData.product);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    useEffect(()=>{
        setPrice("")
        setSelectedUnit("")
    },[selectedItem,selectedItem2])

    return (
        <>
            <main
                className="m-5 p-5 xl:grid grid-cols-2 gap-10 xl:items-start"
                style={{
                    maxWidth: "1920px",
                    margin: "auto",
                }}
            >
                <section>
                    <div className="bg-white p-5 rounded shadow">
                        <div className="flex flex-col justify-center">
                            <div>
                                <img className="border-dashed mb-1 w-full h-full hover:bg-[#b5bac5] transition 1s cursor-pointer border-4 border-light-blue-500" src={companylogo} alt="" />

                                {/* Input for changing the logo */}
                                <input type="file" accept="image/*" onChange={handleLogoChange} />

                                {/* Button to reset to the default logo */}
                                <button className="bg-black text-white ml-3 p-2 rounded-md" onClick={() => setCompanyLogo(defaultLogoUrl)}>
                                    Reset to Default Logo
                                </button>
                                <button className="bg-red-800 text-white ml-3 p-2 rounded-md" onClick={clearFields}>
                                    Clear
                                </button>
                            </div>
                            <article className="md:grid grid-cols-2 gap-10">

                                <FormControl fullWidth>
                                    <InputLabel id="Salesman">Salesman</InputLabel>
                                    <Select
                                        labelId="Salesman"
                                        id="Salesman"
                                        value={Salesman}
                                        label="Salesman"
                                        onChange={(e, item) => {
                                            setSalesman(e.target.value)
                                            setSalesmanId(item.props.id)
                                        }}
                                        sx={{ mb: 4 }}
                                    >
                                        {SalesmanData?.map((salesman, index) => (
                                            <MenuItem key={index} id={salesman.id} value={salesman.fullname}>
                                                {`${salesman.fullname}`}<span className=" ml-2 text-[12px] italic text-gray-500">ID: {salesman.id}</span>
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </article>

                            {/* {Salesman !== "" ? (<span className="text-red-600 mb-3 underline cursor-pointer italic font-poppins" onClick={deleteSalesman}>Want to delete, {Salesman}?</span>) : (null)} */}
                            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />


                            <article className="md:grid grid-cols-1 gap-10">
                                <div className="flex flex-col gap-4">
                                        <article className="md:grid grid-cols-2 gap-5">
                                            <FormControl fullWidth>
                                            <InputLabel id="clientname">Client's name</InputLabel>
                                            <Select
                                            labelId="clientname"
                                            id="clientname"
                                            value={Clientname}
                                            label="Clientname"
                                            onChange={(e) => {
                                                setClientname(e.target.value);
                                                handleClientChange(e.target.value);
                                            }}
                                            sx={{ }}
                                            >
                                            <MenuItem value="" disabled>
                                                Select a Client
                                            </MenuItem>
                                            <ListSubheader>
                                                <TextField
                                                size="small"
                                                autoFocus
                                                placeholder="Type to search..."
                                                fullWidth
                                                InputProps={{
                                                    startAdornment: (
                                                    <InputAdornment position="start">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                    )
                                                }}
                                                onChange={(e) => setSearchTextClient(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key !== "Escape") {
                                                    e.stopPropagation();
                                                    }
                                                }}
                                                />
                                            </ListSubheader>
                                            {displayedClientOptions.map((client, index) => (
                                                <MenuItem key={index} value={client.companyname}>
                                                {`${client.companyname} (ID: ${client.id})`}
                                                </MenuItem>
                                            ))}
                                            </Select>
                                            </FormControl>
                                            <div className=" flex gap-3 items-center w-full">
                                                <p className=" text-[20px] italic">OR</p>
                                                <Link className=" w-full" to="/dashboard/clients"><button className="hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400 bg-blue-800 font-bold text-white w-full p-2 rounded-md">+ Add New Client</button></Link>
                                            </div>
                                        </article>
                                    <article className="md:grid grid-cols-2 gap-5">
                                    <div className="flex flex-col">
                                    <label htmlFor="clientAddress">
                                        Client's address
                                    </label>
                                    <input
                                        type="text"
                                        name="clientAddress"
                                        id="clientAddress"
                                        placeholder="Client's address"
                                        autoComplete="off"
                                        value={clientAddress}
                                        onChange={(e) => setClientAddress(e.target.value)}
                                        disabled
                                    />
                                    </div>
                                    <div className="flex flex-col">
                                    <label htmlFor="clientPhone">
                                        Client's phone
                                    </label>
                                    <input
                                        type="text"
                                        name="clientPhone"
                                        id="clientPhone"
                                        placeholder="Client's phone"
                                        autoComplete="off"
                                        value={ClientPhone}
                                        onChange={(e) => setClientPhone(e.target.value)}
                                        disabled
                                    />
                                    </div>
                                    <div className="flex flex-col">
                                    <label htmlFor="clientID">
                                        Client's ID
                                    </label>
                                    <input
                                        type="text"
                                        name="clientID"
                                        id="clientID"
                                        placeholder="Client's ID"
                                        autoComplete="off"
                                        value={clientID}
                                        disabled
                                    />
                                    </div>
                                    {/* {lpoNumber && ( */}
                                        <div className="flex flex-col">
                                        <label htmlFor="clientID">
                                            Client's Lpo Number
                                        </label>
                                        <input
                                            type="text"
                                            name="clientLpo"
                                            id="clientLpo"
                                            placeholder="Client's Lpo No."
                                            autoComplete="off"
                                            value={lpoNumber}
                                            onChange={(e) => setLpoNumber(e.target.value)}
                                        />
                                        </div>
                                    {/* )} */}
                                    </article>
                                </div>
                            </article>
                            {/* <Link className=" w-fit" to="/clients"><button className="hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400 bg-blue-800 mb-3 w-[100px] font-bold text-white ml-3 p-2 rounded-md">+ Client</button></Link> */}
                            <article className="md:grid grid-cols-3 gap-10">
                                <div className="flex flex-col">
                                    <label htmlFor="notenumber">Note Number</label>
                                    <input
                                        type="text"
                                        name="notenumber"
                                        id="notenumber"
                                        min="0"
                                        placeholder="Note Number"
                                        autoComplete="off"
                                        value={notenumber}
                                        onChange={(e) => setnotenumber(e.target.value)}
                                        disabled
                                    />
                                </div>

                                <div className="flex flex-col">
                                    <label htmlFor="noteDate">Note Date</label>
                                    <input
                                        type="date"
                                        name="noteDate"
                                        id="noteDate"
                                        placeholder="Note Date"
                                        autoComplete="off"
                                        value={noteDate}
                                        onChange={(e) => setNoteDate(e.target.value)}
                                    />
                                </div>

                                <div className="flex flex-col">
                                    <label htmlFor="time">Time</label>
                                    <input
                                        type="time"
                                        name="time"
                                        id="time"
                                        placeholder="Time"
                                        autoComplete="off"
                                        value={time}
                                        onChange={(e) => setTime(e.target.value)}
                                    />
                                </div>
                            </article>

                            <article>
                                <ToastContainer position="top-right" theme="colored" />
                                <div className=" flex gap-3 items-center justify-between mb-3">
                                        <button className=" w-1/2 py-1 text-center text-white bg-green-700 rounded-lg" onClick={(e)=>{setToggle(false); setStock("")}}>Select Item/Service</button>
                                        <button className=" w-1/2 py-1 text-center text-white bg-blue-600 rounded-lg" onClick={(e)=>{setToggle(true); setStock("")}}>Select Product</button>
                                    </div>

                                    {toggle === false && (<>
                                        <Box sx={{  }}>
                                            <FormControl fullWidth>
                                                <InputLabel id="item">Item & Services</InputLabel>
                                                <Select
                                                labelId="item"
                                                id="item"
                                                value={selectedItem}
                                                label="Item & Services"
                                                onChange={(e,item) => {
                                                    setSelectedItem(e.target.value)
                                                    setItemId(item.props.id)
                                                    itemStockFunc(e.target.value)
                                                    setSelectedItemName(e.target.value)
                                                }}
                                                sx={{ mb: 1 }}
                                                >
                                                <MenuItem value="" disabled>
                                                    Select an Item
                                                </MenuItem>
                                                <ListSubheader>
                                                    <TextField
                                                    size="small"
                                                    autoFocus
                                                    placeholder="Type to search..."
                                                    fullWidth
                                                    InputProps={{
                                                        startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon />
                                                        </InputAdornment>
                                                        )
                                                    }}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        if (e.key !== "Escape") {
                                                        e.stopPropagation();
                                                        }
                                                    }}
                                                    />
                                                </ListSubheader>
                                                <ListSubheader sx={{fontSize:18, color:"grey", borderBottom:1, borderTop:1, fontStyle:"italic"}}>Services</ListSubheader>
                                                {displayedOptions.filter(item => item.type === 'Service').map((item, index) => (
                                                    <MenuItem key={index} id={item.id} value={item.itemservice}>
                                                        {`${item.itemservice}`}<span className=" ml-2 text-[12px] italic text-gray-500">ID: {item.id}</span>
                                                    </MenuItem>
                                                ))}
                                                <ListSubheader sx={{fontSize:18, color:"grey", borderBottom:1, borderTop:1, fontStyle:"italic"}}>Items</ListSubheader>
                                                {displayedOptions.filter(item => item.type === 'Item').map((item, index) => (
                                                    <MenuItem key={index} id={item.id} value={item.itemservice}>
                                                        {`${item.itemservice}`}<span className=" ml-2 text-[12px] italic text-gray-500">ID: {item.id}</span>
                                                    </MenuItem>
                                                ))}
                                                </Select>
                                            </FormControl>
                                            <button onClick={NameToggle} className=" mb-1 w-full text-center bg-transparent flex justify-end items-center  gap-1 text-green-600">
                                                    <p className=" italic">Edit Name</p>
                                                    {React.createElement(
                                                        FaAngleDown,    
                                                        {
                                                        size: "15",
                                                        style: {
                                                            transform: editName ? 'rotate(180deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.3s ease',
                                                            transitionDelay: `${0 + 0.7}00ms`, // Adjust duration and easing as needed
                                                        }
                                                        }
                                                    )}
                                                </button>
                                                {(selectedItem && (editName === true )) &&
                                                    <>
                                                        <input
                                                            type="text"
                                                            name="itemName"
                                                            id="itemname"
                                                            disabled={false}
                                                            placeholder={selectedItemName}
                                                            value={selectedItemName}
                                                            onChange={(e) => setSelectedItemName(e.target.value)}
                                                            className=" text-black w-full"
                                                        />
                                                    </>}
                                        </Box>
                                    { (
                                        
                                        <>
                                            <FormControl fullWidth>
                                                <InputLabel id="unit">Unit of Measurement</InputLabel>
                                                <Select
                                                    labelId="unit"
                                                    id="unit"
                                                    value={selectedUnit}
                                                    label="Unit of Measurement"
                                                    onChange={(e) => {
                                                        setSelectedUnit(e.target.value)
                                                        priceFunc(e.target.value)
                                                    }}
                                                    sx={{ mb: 4 }}
                                                >
                                                    {unitData.map((unit, index) => (
                                                        <MenuItem key={index} value={unit.uom}>
                                                            {unit.uom}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </>
                                    )}
                                    </>)}


                                    {toggle === true && (<>
                                        <Box sx={{  }}>
                                    <FormControl fullWidth>
                                        <InputLabel id="product">Products List</InputLabel>
                                        <Select
                                        labelId="product"
                                        id="product"
                                        value={selectedItem2}
                                        label="Item & Services"
                                        onChange={(e,item) => {
                                            setSelectedItem2(e.target.value)
                                            setProductId(item.props.id)
                                            getItemInfo(item.props.id)
                                            setSelectedItemName2(e.target.value)
                                        }}
                                        sx={{ mb: 1 }}
                                        >
                                        <MenuItem value='' disabled>
                                            Select a Product
                                        </MenuItem>
                                        <ListSubheader>
                                            <TextField
                                            size="small"
                                            autoFocus
                                            placeholder="Type to search..."
                                            fullWidth
                                            InputProps={{
                                                startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                                )
                                            }}
                                            onChange={(e) => setSearchText2(e.target.value)}
                                            onKeyDown={(e) => {
                                                if (e.key !== "Escape") {
                                                e.stopPropagation();
                                                }
                                            }}
                                            />
                                        </ListSubheader>
                                        {displayedOptions2.map((product, index) => (
                                            <MenuItem key={index} id={product.id} value={product.product_name}>
                                                {`${product.product_name}`}<span className=" ml-2 text-[12px] italic text-gray-500">ID: {product.id}</span>
                                            </MenuItem>
                                        ))}
                                        </Select>
                                    </FormControl>
                                    <button onClick={NameToggle} className=" mb-1 w-full text-center bg-transparent flex justify-end items-center gap-1 text-green-600">
                                                    <p className=" italic">Edit Name</p>
                                                    {React.createElement(
                                                        FaAngleDown,    
                                                        {
                                                        size: "15",
                                                        style: {
                                                            transform: editName ? 'rotate(180deg)' : 'rotate(0deg)',
                                                            transition: 'transform 0.3s ease',
                                                            transitionDelay: `${0 + 0.7}00ms`, // Adjust duration and easing as needed
                                                        }
                                                        }
                                                    )}
                                                </button>
                                                {(selectedItem2 && (editName === true )) &&
                                                    <>
                                                        <input
                                                            type="text"
                                                            name="itemName"
                                                            id="itemname"
                                                            disabled={false}
                                                            placeholder={selectedItemName2}
                                                            value={selectedItemName2}
                                                            onChange={(e) => setSelectedItemName2(e.target.value)}
                                                            className=" text-black w-full"
                                                        />
                                                    </>}
                                    </Box>
                                    {(

                                        <>
                                            <FormControl fullWidth>
                                                <InputLabel id="unit">Unit of Measurement</InputLabel>
                                                <Select
                                                    labelId="unit"
                                                    id="unit"
                                                    value={selectedUnit}
                                                    label="Unit of Measurement"
                                                    onChange={(e) => {
                                                        setSelectedUnit(e.target.value)
                                                        priceFunc(e.target.value)
                                                    }}
                                                    sx={{ mb: 4 }}
                                                >
                                                    {unitData.map((unit, index) => (
                                                        <MenuItem key={index} value={unit.uom}>
                                                            {unit.uom}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </>
                                        )}
                                    </>)}


                                <div className="md:grid grid-cols-3 gap-10">
                                    <div className="flex flex-col">
                                        <label htmlFor="quantity">Quantity</label>
                                        <input
                                            type="number"
                                            name="quantity"
                                            id="quantity"
                                            min="0"
                                            placeholder="Quantity"
                                            value={quantity}
                                            onChange={(e) => setQuantity(e.target.value)}
                                        />
                                    </div>

                                    <div className="flex flex-col">
                                        <label htmlFor="delQuantity">Delivered Qty</label>
                                        <input
                                            type="number"
                                            name="delQuantity"
                                            id="delQuantity"
                                            min="0"
                                            placeholder="Delivered Quantity"
                                            value={delQuantity}
                                            onChange={(e) => setDelQuantity(e.target.value)}
                                        />
                                    </div>

                                    {type === "Item" ? (<div className="flex flex-col">
                                                <label htmlFor="stock">Stock</label>
                                                <input
                                                    type="number"
                                                    name="Stock"
                                                    id="Stock"
                                                    min="0"
                                                    disabled={true}
                                                    placeholder="Stock"
                                                    value={stock}
                                                    onChange={(e) => setStock(e.target.value)}
                                                />
                                            </div>):(null)}

                                    <div className="flex flex-col">
                                        <label htmlFor="price">Price</label>
                                        <input
                                          
                                            type="number"
                                            name="price"
                                            id="price"
                                            placeholder="Price"
                                            value={price}
                                            onChange={(e) => setPrice(e.target.value)}
                                        />
                                    </div>

                                    <div className="flex flex-col">
                                        <label htmlFor="amount">Amount</label>
                                        <p className="text-[20px] mt-[7px] font-poppins text-red-600">{amount}</p>
                                    </div>
                                </div>
                            </article>
                            {(selectedItem.length > 0 || selectedItem2.length > 0) && quantity > 0  && !(type === "Item" && (stock < quantity)) ? (<button className="text-5xl font-poppins bg-green-800 font-bold text-white" onClick={addToTable}>+</button>) : (null)}
                            <table width="100%" className="mb-10 overflow-auto">
                                <thead>
                                    <tr className=" text-center bg-gray-100 p-1">
                                        <td className="font-bold">Description</td>
                                        <td className="font-bold">Quantity</td>
                                        <td className="font-bold">Price</td>
                                        <td className="font-bold">Amount</td>
                                        <td className="font-bold">Actions</td>
                                    </tr>
                                </thead>
                                {list?.map(({ id, itemdesc, quantity, price, amount }, index) => (
                                    <React.Fragment key={id}>
                                        <tbody>
                                            <tr className=" text-center h-10">
                                                <td>{itemdesc}</td>
                                                <td>{quantity}</td>
                                                <td>{price}</td>
                                                <td className="amount">{amount}</td>
                                                <td>
                                                    <button className="text-3xl font-poppins text-red-700" onClick={() => removeItem(index)}>x</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </React.Fragment>
                                ))}
                            </table>

                            <label htmlFor="notes">Description</label>
                            <textarea
                                name="notes"
                                id="notes"
                                cols="30"
                                rows="2"
                                placeholder="Notes Description"
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                            ></textarea>

                            {triggerNote && (<button onClick={addNote} className="bg-green-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                                {AddNoteButtonStatetext}
                            </button>)}
                           
                            {triggerPrint && (<ReactToPrint
                                onAfterPrint={()=>{
                                    clearFields()
                                    handleChild()
                                }}
                                trigger={() => (
                                <button className="bg-green-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-green-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-green-400">
                                    Click here to Print
                                </button>
                                )}
                                content={() => componentRef.current}
                            />)}
                        </div>
                    </div>
                </section>




                {/* Note Preview */}
                <div className="note__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                    <ReactToPrint
                        trigger={() => (
                            <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                                Print / Download
                            </button>
                        )}
                        content={() => componentRef.current}
                    />
                    <div ref={componentRef} className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative">
                        <div>
                            <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                                <div>

                                    <img  src={companylogo} alt="logo" />
                                </div>
                            </div>
                            <article className=" py-2 text-center text-base text-black border-t border-b border-black uppercase w-full font-bold">
                                <p>Delivery Note</p>
                            </article>
                            <div className=" flex justify-between my-5">
                                <article className=" flex items-start justify-start">
                                    <ul>
                                        <li className="p-1 ">
                                            <span className="font-bold">Customer's name:</span> {Clientname}
                                        </li>
                                        <li className="p-1 ">
                                            <span className="font-bold">Customer's ID:</span> {clientID}
                                        </li>
                                        <li className="p-1">
                                            <span className="font-bold">Address:</span> {clientAddress}
                                        </li>
                                        <li className="p-1 ">
                                            <span className="font-bold">Phone:</span> {ClientPhone}
                                        </li>
                                    </ul>
                                </article>
                                <article className=" flex items-end justify-end">
                                    <ul>
                                        <li className="p-1 ">
                                            <span className="font-bold">Delivery Note number:</span> {notenumber}
                                        </li>
                                        <li className="p-1 ">
                                            <span className="font-bold">Delivery Note date:</span> {noteDate}
                                        </li>
                                        <li className="p-1 ">
                                            <span className="font-bold">Time:</span> {time}
                                        </li>
                                        {/* {lpoNumber && ( */}
                                            <li className="p-1 ">
                                                <span className="font-bold">LPO No:</span> {lpoNumber}
                                            </li>
                                        {/* )} */}
                                    </ul>
                                </article>
                            </div>

                            <table width="100%" className="mb-10">
                                <thead>
                                    <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold text-center">
                                        <td className="font-bold">S.No.</td>
                                        <td className="font-bold">Item Code</td>
                                        <td className="font-bold">Description</td>
                                        <td className="font-bold">UOM</td>
                                        <td className="font-bold text-center">Quantity</td>
                                        <td className="font-bold text-center">Delivered Qty.</td>
                                        {/* <td className="font-bold">Price</td> */}
                                        {/* <td className="font-bold">Total</td> */}
                                    </tr>
                                </thead>
                                {list?.map(({ id, itemdesc,uom, delQuantity, quantity, price, amount }, index) => (
                                    <React.Fragment key={id}>
                                        <tbody>
                                            <tr className=" text-center h-10 text-center">
                                                <td>{index + 1}</td>
                                                <td>{id}</td>
                                                <td>{itemdesc}</td>
                                                <td>{uom}</td>
                                                <td className=" text-center">{quantity}</td>
                                                <td className=" text-center">{delQuantity}</td>
                                                {/* <td>{price}</td> */}
                                                {/* <td>{amount}</td> */}
                                            </tr>
                                        </tbody>
                                    </React.Fragment>
                                ))}
                            </table>

                            {/* <div className=" flex flex-col gap-2">
                                <h2 className="flex items-end justify-end text-gray-800 text-2xl font-bold ">
                                   Net Total: QAR {total.toLocaleString()} 
                                </h2>
                            </div> */}
                        </div>
                        {notes &&                        
                            <section className="mt-10 mb-5">
                                <h3>Description</h3>
                                <p className="lg:w-1/2 text-justify">{notes}</p>
                            </section>
                        }

                        <footer className= " footer border-t-2 border-gray-300 pb-5">
                            <div className=" w-full flex justify-evenly pt-4 pb-20 px-5 border-b border-gray-300 mb-2 text-base">
                                <p>Prepared By</p>
                                <p>Approved By</p>
                                <p>Delivered By</p>
                                <p className=" ">Reciever's Name, Signature & Contact No. </p>

                            </div>
                            <ul className="flex flex-wrap items-center gap-2 justify-center">
                                <li>
                                    <span className="font-bold">Email:</span> {"arcoglassqatar@gmail.com"}
                                </li>
                                <li>
                                    <span className="font-bold">Tel:</span> {"4460 5198"}<span className="ml-1 font-bold">-Fax:</span> {"4451 7172"}
                                </li>
                                <li>
                                    <span className="font-bold">P.O Box:</span> {"40992, Doha-Qatar "}
                                </li>
                            </ul>
                            <p className="text-center px-5 mt-4 text-xs ">
                            Thankyou for your purchase!
                        </p>
                        </footer>

                    </div>
                </div>
            </main>
        </>
    )
}

export default NoteForm